<script lang="ts" setup>
// ================================
// IMPORTS
// ================================

// Les attributs (class, etc.) sont hérités par la racine BaseCard
type Props = {
    headerClass?: string
    contentClass?: string
}

withDefaults(defineProps<Props>(), {
    contentClass: "",
    headerClass: "",
})
</script>

<template>
    <BaseCard
        :pt="{
            content: contentClass,
        }"
    >
        <template #header>
            <div
                class="border-b border-solid border-gray-200 p-6 text-lg font-semibold text-primary bg-gray-50 w-full rounded-t-md"
                :class="headerClass"
            >
                <slot name="header"></slot>
            </div>
        </template>
        <template #content>
            <slot name="content"></slot>
        </template>
        <template v-if="$slots.footer" #footer>
            <slot name="footer"></slot>
        </template>
    </BaseCard>
</template>
